export const workInProgress = {
  text: 'This section is currently under development.',
  action: 'Back to Home',
  goBack: 'Go Back'
};
